import { c as _c } from "react/compiler-runtime";
import { AuthorHeaderSocialMediaAccount } from '#components/Author/AuthorHeaderSocialMediaAccount';
import { notNullOrUndefined } from '#cutils/misc/notNullOrUndefined';
import styles from './AuthorHeaderSocialMediaAccounts.module.scss';
import { getSocialMediaUrl } from './AuthorHeaderSocialMediaAccounts.utils';
import type { AuthorHeaderSocialMediaAccountsFragment } from './__generated__/AuthorHeaderSocialMediaAccounts.generated';
type Props = {
  socialMediaAccounts: AuthorHeaderSocialMediaAccountsFragment['socialMediaAccounts'];
  className?: string;
};
export function AuthorHeaderSocialMediaAccounts(t0) {
  const $ = _c(7);
  const {
    socialMediaAccounts,
    className
  } = t0;
  let t1;
  if ($[0] !== className || $[1] !== socialMediaAccounts) {
    let t2;
    if ($[3] !== className) {
      t2 = socialMediaAccount => {
        const socialMediaUrl = getSocialMediaUrl(socialMediaAccount, false);
        return <AuthorHeaderSocialMediaAccount key={`${socialMediaAccount.accountName}-${socialMediaAccount.label}`} label={socialMediaAccount.label} service={socialMediaAccount.service} url={socialMediaUrl} className={className} />;
      };
      $[3] = className;
      $[4] = t2;
    } else {
      t2 = $[4];
    }
    t1 = (socialMediaAccounts || []).filter(notNullOrUndefined).map(t2);
    $[0] = className;
    $[1] = socialMediaAccounts;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const mappedSocialMediaAccounts = t1;
  let t2;
  if ($[5] !== mappedSocialMediaAccounts) {
    t2 = <ul className={styles.wrapper}>{mappedSocialMediaAccounts}</ul>;
    $[5] = mappedSocialMediaAccounts;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}